module.exports = __webpack_public_path__ + "media/checkout/vipBox-458859bb.svg";